module.exports = __webpack_public_path__ + "static/media/21ECLAC39.11a98e09.jpg";